import { createSlice } from '@reduxjs/toolkit';

type ContainerStatusState = {
  filterSearchData: any;
  filterSearchTotal: number;
  loading: boolean;
};

const initialState: ContainerStatusState = {
  filterSearchData: [],
  filterSearchTotal: 0,
  loading: false,
};

export const containerStatusSlice = createSlice({
  name: 'containerStatus',
  initialState,
  reducers: {
    filterContainer: (state, action) => {
      state.filterSearchData = [];
      state.loading = true;
    },
    filterContainerSuccess: (state, action) => {
      state.filterSearchData = action.payload.records;
      state.filterSearchTotal = action.payload.total;
      state.loading = false;
    },
    updateContainer: (state, action) => {
      state.loading = true;
    },
    updateContainerSuccess: (state, action) => {
      state.loading = false;
    },
    clearData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const { filterContainer, filterContainerSuccess, updateContainer, updateContainerSuccess, clearData } =
  containerStatusSlice.actions;

export default containerStatusSlice.reducer;
